<template>
    <div class="setting-style-width d-flex flex-column justify-content-center">
        <div class="w-100 pb-2 d-flex align-items-center">
            <label for="styleTextAlign" class="font-14 m-0">
                Alinhamento Vertical
            </label>
        </div>

        <div class="row no-gutters">
            <button
                v-for="(align, key) in aligns"
                :key="key"
                class="button-align col-4"
                :class="align.value ==  alignActive? 'active' : ''"
                @click="setAlign(align.value)"
                :disabled="isLockVerticalAlign"
            >
                <div class="d-flex justify-content-center align-items-center">
                    <div v-html="align.icon"></div>
                </div>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SettingFrameVerticalAlign',
    props: {
        item: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            alignActive: 'start',
            aligns: [
                { id: 1, name: "Alinhar ao Topo", value: 'start', icon: `<svg xmlns="http://www.w3.org/2000/svg" width="26.081" height="22.25" fill="var(--main-color)" viewBox="0 0 26.081 22.25"><defs><style>.a{fill:var(--main-color)}.b{fill:none;stroke:var(--main-color)stroke-linecap:round;stroke-width:2px;}</style></defs><g transform="translate(-379.899 -331.5)"><rect class="a" width="6.932" height="17.878" rx="1" transform="translate(391.298 353.75) rotate(180)"/><rect class="a" width="6.932" height="12.041" rx="1" transform="translate(401.514 347.912) rotate(180)"/><line style="stroke:var(--main-color); fill: var(--main-color)" class="b" x2="24.081" transform="translate(404.98 332.5) rotate(180)"/></g></svg>` },
                { id: 2, name: "Alinhar ao centro", value: 'center', icon: `<svg xmlns="http://www.w3.org/2000/svg" width="26.081" height="17.878" fill="var(--main-color)" viewBox="0 0 26.081 17.878"><defs><style>.a{fill:var(--main-color)}.b{fill:none;stroke:var(--main-color)stroke-linecap:round;stroke-width:2px;}</style></defs><g transform="translate(-425.213 -334.186)"><g transform="translate(-606.686 -630.891)"><rect class="a" width="6.932" height="17.878" rx="1" transform="translate(1043.298 982.955) rotate(180)"/><rect class="a" width="6.932" height="12.041" rx="1" transform="translate(1053.514 980.117) rotate(180)"/><line style="stroke:var(--main-color); fill: var(--main-color)" class="b" x2="24.081" transform="translate(1056.98 973.576) rotate(180)"/></g></g></svg>`},
                { id: 3, name: "Alinhar a baixo", value: 'end', icon: `<svg xmlns="http://www.w3.org/2000/svg" width="26.081" height="22.25" fill="var(--main-color)" viewBox="0 0 26.081 22.25"><defs><style>.a{fill:var(--main-color)}.b{fill:none;stroke:var(--main-color)stroke-linecap:round;stroke-width:2px;}</style></defs><g transform="translate(-469.899 -332.5)"><g transform="translate(-606.686 -630.891)"><rect class="a" width="6.932" height="17.878" rx="1" transform="translate(1087.983 981.269) rotate(180)"/><rect class="a" width="6.932" height="12.041" rx="1" transform="translate(1098.2 981.269) rotate(180)"/><line style="stroke:var(--main-color); fill: var(--main-color)" class="b" x2="24.081" transform="translate(1101.666 984.641) rotate(180)"/></g></g></svg>`},
            ],
        }
    },
    methods: {
        onChangeVerticalAlign() {
            this.$emit('onChangeVerticalAlign', this.alignActive);
        },
        setAlign(align) {
            this.alignActive = align;
        }
    },
    computed: {
        isLockVerticalAlign() {
            return this.item.extra.style_verical_align_lock;
        },
    },
    watch: {
        alignActive() {
            this.onChangeVerticalAlign();
        },
    },
    created() {
        if (this.item.extra && this.item.extra.vertical_align) {
            this.alignActive = this.item.extra.vertical_align;
        }
    },
}
</script>

<style scoped>
.button-align {
    background: transparent;
    border: 2px solid transparent;
    border-radius: 5px;
    outline: none;
    padding: 0.5rem;
    margin: 0;
    width: 100%;
    height: 100%;
}

.button-align.active {
    border: 2px solid var(--main-color);
}

#deslock,
#lock {
    background: transparent;
    border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/atoms/SettingFrameVerticalAlign.vue